module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EquityCustomizeView.js"));
	}, "EquityCustomizeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityCustomizeView!./src/pages/Promote/Equity/EquityCustomize/EquityCustomizeView.js
// module id = 2068
// module chunks = 367